import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Box } from 'grommet/components/Box';
import { Text } from 'grommet/components/Text';
import { Link } from 'react-router-dom';
import ReactTable from "react-table";
/*import InfoTable from './../Components/InfoTable';*/
import Pagination from './../Components/Pagination';
import data from '../Data.json';
import ReactExport from "react-data-export";
import { GetStatisticsCtrl } from '../Controllers/Transaction/GetStatisticsCtrl';
import ModalErrorTimeout from '../Components/ModalErrorTimeout';
import { loader, noData, formatAmount } from '../Utils/Utility';


const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

class StatisticaMensile extends Component {
    static propTypes = {
        match: PropTypes.object,
        location: PropTypes.object,
        history: PropTypes.object
    }
    constructor(props) {
        super(props);
        this.state = {
            data: data,
            search: '',
            minamount: '',
            maxamount: '',
            minamountnet: '',
            maxamountnet: '',
            codesoc: "9285568127",
            codepos: "9523119287",
            codepv: sessionStorage.getItem("codSocietario") === '0' ? "" : sessionStorage.getItem("code") ? sessionStorage.getItem("code") : '',
            selectedMonth: '',
            selectedDay: '',
            selectedMov: '',
            selected: {},
            showresult: false,
            showTimeoutModal: false,
            typePeriod: 's',
            value: [],
            isRicerca: false
        }
        this.setAmount = this.setAmount.bind(this);
        this.setSelectionMonth = this.setSelectionMonth.bind(this);
        this.setSelectionDay = this.setSelectionDay.bind(this);
        this.setSelectionMovements = this.setSelectionMovements.bind(this);
        this.showResult = this.showResult.bind(this);
    }

    componentDidMount() {
        var token = sessionStorage.getItem('token')
        var ids = sessionStorage.getItem('ids')
        const self = this;

        this.setState({
            isRicerca: true
        },()=>{

            //Get Statistics 
            GetStatisticsCtrl(function (data) {
                self.setState({
                    dataTable: data === '' ? [] : data,
                    isRicerca: false
                });
            }, function (error) {
                self.setState({
                    status: error
                }, function(){
                    if(this.state.status === 500 || this.state.status === 400 || this.state.status === 404 || this.state.status === 403){
                        this.props.history.push({
                            pathname: '/ErrorPage',
                            state: this.state
                        })  
                    } else if (this.state.status === 401) {
                        this.setState({
                            showTimeoutModal: true
                        })
                    } 
                })

            }, this.state, token, ids);
        });
    }

    setPoint(i) {

        const newSelected = this.state.selected;
        const newValue = this.state.value;
        newSelected[i] = !this.state.selected[i];
        newValue[i] = [i];

        this.setState({
            selected: newSelected,
            value: newValue
        })
    }

    setAmount(event) {
        if (event.target.id === 'minamount') {
            this.setState({
                minamount: event.target.value
            })
        } else if (event.target.id === 'maxamount') {
            this.setState({
                maxamount: event.target.value
            })
        } else if (event.target.id === 'minamountnet') {
            this.setState({
                minamountnet: event.target.value
            })
        } else if (event.target.id === 'maxamountnet') {
            this.setState({
                maxamountnet: event.target.value
            })
        } else if (event.target.id === 'codpos') {
            this.setState({
                codpos: event.target.value
            })
        }
    }

    setSelectionMonth(event) {
        this.setState({
            selectedMonth: event.value
        })
    }

    setSelectionDay(event) {
        this.setState({
            selectedDay: event.value
        })
    }

    setSelectionMovements(event) {
        this.setState({
            selectedMov: event.value
        })
    }


    showResult() {
        if (this.state.selectedMonthYear !== '') {
            return (
                this.setState({
                    showresult: !this.state.showresult

                })
            )
        }

    }


    render() {
        
        const insegna = sessionStorage.getItem('insegna')
        const codesoc = sessionStorage.getItem('codesoc')
        const codepos = sessionStorage.getItem('codepos')
        const codSocietario = sessionStorage.getItem('codSocietario')

        const columns = [

            {
                Header: 'ANNO',
                accessor: 'year',
                headerClassName: 'sH',
                style: {
                    fontSize: '10px'
                }
            },
            {
                Header: 'SEQUENZA',
                accessor: 'sequence',
                headerClassName: 'sH',
                style: {
                    fontSize: '10px'
                }
            },
            {
                Header: 'NUMERO TRANSAZIONI',
                accessor: 'numberOfTransaction',
                headerClassName: 'sH',
                style: {
                    fontSize: '10px'
                }
            },
            {
                Header: 'LORDO',
                accessor: 'grossAmount',
                headerClassName: 'sH',
                style: {
                    fontSize: '10px'
                },
                Cell: (row) => formatAmount(row.original.grossAmount)
            },
            {
                Header: 'COMMISSIONE',
                accessor: 'feeAmount',
                headerClassName: 'sH',
                style: {
                    fontSize: '10px'
                },
                Cell: (row) => formatAmount(row.original.feeAmount)
            },
            {
                Header: 'NETTO',
                accessor: 'netAmount',
                headerClassName: 'sH',
                style: {
                    fontSize: '10px'
                },
                Cell: (row) => formatAmount(row.original.netAmount)
            },

        ]

        const hasData = (Array.isArray(this.state.dataTable) && this.state.dataTable.length > 0 && this.state.dataTable !== null && this.state.dataTable !== undefined)

        return (
            <Box>
                {this.state.showTimeoutModal ? <ModalErrorTimeout /> : ''}
                <Box align='center' className='content' style={{ backgroundColor: '#f9f9f9', marginTop: '0' }}>

                    <Box className='contentbox'>
                        <Box pad='medium' align='start'>
                            <Text className='titlehome'>Consulta Statistica Semestrale</Text>
                        </Box>

                        <Box>
                            <Box className='containerMenu'>
                                <Box className='floatTextLeftstat' direction='row'>
                                    <Box className='overTCstat'>
                                        <Box className='tdBold'>
                                            Cod Societario:
                                        </Box>
                                        <Box className='tdBold'>
                                            Punto Vendita:
                                        </Box>
                                        <Box className='tdBold'>
                                            Insegna:
                                        </Box>
                                        <Box className='tdBold'>
                                            Periodo:
                                        </Box>
                                    </Box>
                                    <Box className='overTC'>
                                        <Box className='tdNormal'>
                                            {codesoc}
                                        </Box>
                                        <Box className='tdNormal'>
                                            {codSocietario === '0' ? codepos : "Tutti" }
                                        </Box>
                                        <Box className='tdNormal'>
                                            {insegna}
                                        </Box>
                                        <Box className='tdNormal'>
                                            Semestrale
                                        </Box>
                                    </Box>
                                </Box>
                            </Box>
                            <Box direction='row'>
                                <Box pad='large' style={{ 'overflow-x': 'auto', width: '100%', padding: '0' }}>
                                    {hasData ? 
                                        <ReactTable
                                        PaginationComponent={Pagination}
                                        data={this.state.dataTable}
                                        columns={columns}
                                        sortable={true}
                                        multiSort={true}
                                        resizable={true}
                                        showPagination={true}
                                        loading={false}
                                        defaultPageSize={5}
                                        style={{ paddingBottom: '20px' }} />

                                        : this.state.isRicerca ?
                                            loader

                                        : noData
                                    }
                                </Box>
                            </Box>

                            <Box direction='row' className='footerTable rowColumn'>
                                <Box className='contentXsls'>
                                    <ExcelFile filename='Statistica Semestrale' element={<Box direction='row' role="button" aria-label="Esporta la statistica semestrale in formato Excel" tabIndex="0" onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); e.currentTarget.click(); } }} className="export-button" aria-haspopup="true" aria-expanded="false"><Text className='export'>ESPORTA<i className='icon-xlsx-file-format-extension' style={{ fontSize: '20px', marginLeft: '10px', verticalAlign: 'middle' }}></i></Text></Box>}>
                                        <ExcelSheet data={this.state.dataTable} name="Statistica Semestrale">
                                        <ExcelColumn label="ANNO" value="year" />
                                        <ExcelColumn label="SEQUENZA" value="sequence" />
                                        <ExcelColumn label="NUMERO TRANSAZIONI" value="numberOfTransaction" />
                                        <ExcelColumn label="LORDO" value='grossAmount' />
                                        <ExcelColumn label="COMMISSIONE" value='feeAmount' />
                                        <ExcelColumn label="NETTO" value="netAmount" />
                                        </ExcelSheet>
                                    </ExcelFile>
                                </Box>
                                <Box direction='row' className='footerTablelink' gap='small'>
                                    <Link to='/Home/StatisticaMensile'>STATISTICA MENSILE</Link>-
                                <Link to='/Home/StatisticaTrimestrale'>STATISTICA TRIMESTRALE</Link>
                                </Box>
                            </Box>

                        </Box>

                    </Box>
                </Box>
            </Box>
        )
    }
}
export default StatisticaMensile;